module.exports = __webpack_public_path__ + "static/media/mmm-camera.dcc30eba.svg";